module.exports = __webpack_public_path__ + "img/team.a0e9566c.jpg";